export default "__VITE_ASSET__BZpJ2Vo4__"